module.exports = __webpack_public_path__ + "img/bf-bg-long.0bbdf2a2.png";